import useUserStore from "~/stores/user";

export function useUserSubscription() {
  const userStore = useUserStore();

  useAsyncData(
    "user-subscriptions",
    async () => {
      const hasSubscription = await userStore.fetchSubscriptions();
      return { hasSubscription };
    },
    {
      getCachedData: (key) => {
        // Check Nuxt's payload/static data first
        const payloadData = useNuxtApp().payload.data[key] || useNuxtApp().static.data[key];
        if (payloadData) {
          userStore.hasSubscription = payloadData.hasSubscription;
          return payloadData;
        }

        // Check if we already have the value in store (from previous fetch)
        if (userStore.hasSubscription === true) {
          return { hasSubscription: true };
        }

        return undefined;
      },
      watch: [() => userStore.isAuthenticated],
    },
  );

  // Return computed value from store
  return computed(() => userStore.hasSubscription);
}
